import React from 'react';
import { isIOS } from 'react-device-detect';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import NameAndDateLines from '../@common/NameAndDateLines';
import DoubleLinedInput from '../@common/DoubleLinedInput';
import { WorksheetBaseProps } from '../@types';
import { getFontSize } from '../../utils/style-utils';

const portraitLines = [...Array(3).keys()];

type SentenceProps = WorksheetBaseProps & {
  value: string;
  isCursive?: boolean;
  isNarrow?: boolean;
  valueMap: { [key: string]: string };
};

const Sentence = ({ onChange, isCursive, isNarrow, valueMap, printRef }: SentenceProps) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Book';
  const fontSize = getFontSize(isCursive, isNarrow);
  return (
    <PortraitPaperLayout
      isNarrow={isNarrow}
      printRef={printRef}
      className={isIOS ? 'print-scale-down' : ''}
    >
      <NameAndDateLines
        isCursive={isCursive}
        fontFamily={bookFont}
        isNarrow={isNarrow}
        top={0}
        width={775}
      />
      <DoubleLinedInput
        numOfLinesArray={portraitLines}
        onChange={onChange}
        fontFamily={bookFont}
        fontSize={fontSize}
        isNarrow={isNarrow}
        isCursive={isCursive}
        valueMap={valueMap}
      />
    </PortraitPaperLayout>
  );
};

export default Sentence;
